import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/roles`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/roles/${id}`, options)
    .then(response => {
      let roles = jsona.deserialize(response.data);
      delete roles.links;
      return roles;
    });
}

function add(roles) {
  
  console.log(roles);
  const payload = jsona.serialize({
    stuff: roles,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/roles`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(roles) {
  const payload = jsona.serialize({
    stuff: roles,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/roles/${roles.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/roles/${id}`, options);
}

function listByBrand(brand) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/roles?filter[vehicle_brand_id]=${brand}`, options)
    .then(response => {
      let roles = jsona.deserialize(response.data);
      delete roles.links;
      return roles;
    });
}




export default {
  list,
  get,
  add,
  update,
  listByBrand,
  destroy,
};

